<script setup lang="ts">
    import { SearchOutlined } from '@ant-design/icons-vue';
    import type { ChangeEvent } from 'ant-design-vue/es/_util/EventInterface';
    import { useField } from 'vee-validate';

    const props = defineProps({
        inputName: {
            type: String,
            default: 'text', 
        },
        inputType: {
            type: String,
            default: 'text',
        },
        type: {
            type: String as PropType<'search' | 'default'>,
            default: 'default',
            required: false,
        },
        placeholder: {
            type: String,
            default: '',
            required: false
        },
        maxLength: {
            type: Number,
            required: false
        },
        icon: {
            type: String as PropType<'search' | 'none'>,
            default: 'search',
            required: false
        },
        iconClass: {
            type: String,
            default: '',
            required: false
        },
        class: {
            type: String,
            required: false
        },
    })

    // For settings the class depending on the prop.
    const classObject = computed(() => ({
        'rounded-none' : props.type == 'default',
        'rounded-[0.8rem] max-md:rounded-none max-md:h-[4rem]' : props.type == 'search',
    }))

    const updateValue = (event: ChangeEvent) => {
        setValue(event.target.value);
    };

    const { value, setValue, errorMessage }: any = useField(props.inputName)
</script>

<template>
    <a-input
        :class="[
            { 'is-invalid' : errorMessage },
            'w-full text-[1.4rem] font-bold text-[darkGray] placeholder-[darkGray] shadow',
            classObject,
            props.class,
        ]"
        :placeholder="props.placeholder"
        :id="props.inputName"
        :name="props.inputName"
        :maxlength="props.maxLength"
        :value="value"
        :allowClear="true"
        @change="updateValue"
    >
        <template v-if="props.icon !== 'none'" #prefix>
            <SearchOutlined :class="['text-[1.8rem]', 'text-[#171717]', props.iconClass]" />
        </template>
    </a-input>
    <template v-if="errorMessage">
        <p class="text-[redError] text-[1.4rem] leading-[1.5] mt-[.4rem]">
        {{  errorMessage }}
        </p>
    </template>
</template>

